import React from "react";
import { observer } from "mobx-react";
import { Card, Paper, Table, Text, Box, Drawer, Group } from "@mantine/core";

import { Cubby } from "../stores/Cubby";
import { getArticle } from "./docsIndex";

const ArticleTitle = observer(({ cubby }: { cubby: Cubby }) => {
  const article = getArticle(cubby.currentlyFocusedArticleSlug);

  return (
    <Group gap="xs" justify="flex-start" wrap="nowrap">
      {article.icon}
      <Text size={"lg"}>{article.title}</Text>
    </Group>
  );
});

export default ArticleTitle;
